import { defineMessages } from 'react-intl-next';

export const trackChangesMessages = defineMessages({
	toolbarIconLabel: {
		id: 'editor.trackChanges.toolbarIconLabel',
		defaultMessage: 'Track Changes',
		description: 'Label for the track changes toolbar icon',
	},
	removed: {
		id: 'editor.trackChanges.removed',
		defaultMessage: 'Removed',
		description: 'Label for content that has been removed in track changes',
	},
});
